import { ButtonVariant, IconVariants, ListItem, ListItemProps, ListItemVariant } from "@next-platform/client-common-spicy-ui";
import { useTranslation } from "@next-platform/client-common-core";
import { JSX } from "react";

export interface ChatVoiceSelectionListItemProps extends Omit<ListItemProps, "onChange"> {
  onChange?: (isPlay: boolean) => void;
  isPlaying?: boolean;
  loading?: boolean;
  isSelected?: boolean;
  onSelect: () => void;
  isSelectLoading: boolean;
  isDefaultSelected: boolean;
}

export function ChatVoiceSelectionListItem({
  onChange,
  isPlaying,
  loading: _loading,
  isSelected,
  onSelect,
  isSelectLoading,
  isDefaultSelected,
  ...props
}: ChatVoiceSelectionListItemProps): JSX.Element {
  const { t } = useTranslation();
  const defaultSelected = !isSelectLoading && isDefaultSelected;
  const handleListOnPress = () => {
    onChange?.(!isPlaying);
  };

  return (
    <ListItem
      {...props}
      className="min-w-0 [&>div:first-child]:min-w-0 [&>div:first-child>div:last-child]:min-w-0 [&>div:first-child>div:last-child>div:first-child]:min-w-0 [&>div:first-child>div:last-child>div:first-child>*:first-child]:!block [&>div:first-child>div:last-child>div:first-child>*:first-child]:!min-w-0 [&>div:first-child>div:last-child>div:first-child>*:first-child]:!line-clamp-1 [&>div:first-child>div:last-child>div:first-child>*:first-child]:!truncate"
      active={isPlaying}
      onClick={handleListOnPress}
      variant={ListItemVariant.BORDERED}
      subLabelMaxLines={2}
      startAction={{
        iconStart: isPlaying ? IconVariants.PAUSE : IconVariants.PLAY,
        className: "!bg-gray-5 dark:!bg-gray-9 !border-transparent size-[42px]",
        classNames: {
          icon: "fill-gray-12 stroke-gray-12",
        },
        onClick: handleListOnPress,
      }}
      endAction={{
        children: defaultSelected ? t("common:selected") : t("common:select"),
        onClick: onSelect,
        variant: (!isSelectLoading && isDefaultSelected) || (isSelectLoading && isSelected) ? ButtonVariant.SECONDARY : ButtonVariant.INVERSE,
        loading: isSelected && isSelectLoading,
        disabled: !isSelected && isSelectLoading,
        loadingWithText: false,
        className: "transition-none",
      }}
    />
  );
}
